import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EventUserLog = lazy(() =>
  import("@scenes/EventUserLog").then((module) => ({ default: module.EventUserLogForNro }))
);

export const eventUserLogNRO: NavigationRoutingObject = {
  Component: EventUserLog,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("event-user-log-sidebar-pill-menu-option", "Event User Log"),
  getDeveloperNavigationAllowed: () => true,
  featureLimitationKeys: ["can_only_view_gated_feature"],
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("event-user-log-nro-additional-keyword-test-user-log", "test user log"),
        t("event-user-log-nro-additional-keyword-test-user-logs", "test user logs"),
      ],
      description: t(
        "event-user-log-nro-additional-description-see-logs-for-test-users",
        "See logs for test users"
      ),
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
